var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProiconsComputer = function SvgProiconsComputer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5001 126.88H172.5M85.4773 145.869C85.4773 146.192 85.4773 146.53 85.4773 146.881C85.4773 155.479 78.5075 162.451 69.9098 162.451M114.589 145.869C114.589 146.195 114.589 146.533 114.589 146.881C114.589 155.479 121.559 162.451 130.156 162.451M69.8942 162.451L69.9098 166H130.156L130.172 162.451M28.5001 68.0062C28.5001 64.6638 28.5001 58.5599 28.5001 52.9997C28.5 46.3722 33.8724 41 40.4998 41C46.137 41 52.3505 41 55.7433 41H145.257C148.65 41 154.863 41 160.5 41C167.128 41 172.5 46.3722 172.5 52.9996C172.5 58.5598 172.5 64.6638 172.5 68.0062C172.5 89.9604 172.5 111.915 172.5 133.869C172.5 140.496 167.128 145.869 160.5 145.869C154.863 145.869 148.65 145.869 145.257 145.869H55.7433C52.3505 145.869 46.137 145.869 40.4999 145.869C33.8724 145.869 28.5001 140.496 28.5001 133.869C28.5001 111.915 28.5001 89.9604 28.5001 68.0062Z",
    stroke: "black",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.5 70L95.1092 99.3963C94.3272 100.201 93.0475 100.201 92.2655 99.3963L81.5 87.5625",
    stroke: "#07C160",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgProiconsComputer;